const parseLocaleData = data => {
  if (typeof data === "object" && data !== null) {
    return data;
  }

  try {
    return JSON.parse(data);
  } catch (_error) {
    return {};
  }
};

export const createSeoHeadTranslator = ({ localeEdges = [], language, fallbackT }) => {
  const translations = localeEdges
    .map(edge => edge?.node)
    .filter(node => node?.language === language && node?.ns === "common")
    .reduce((result, node) => ({ ...result, ...parseLocaleData(node.data) }), {});

  return (key, fallback, options) => {
    if (Object.prototype.hasOwnProperty.call(translations, key)) {
      return translations[key];
    }

    return fallbackT(key, fallback, options);
  };
};
